<div class="FormsImport">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading) {
        <div class="row">
            <div class="col-12 mb-3">
                {{ 'forms-template-import.title' | locTranslate }}
            </div>
            <div class="col-12 col-sm-6 mb-3">
                <h4 class="mb-3">{{ 'forms-template-import.subtitle-with-template' | locTranslate }}</h4>
                <div>
                    <div>
                        <div class="form-group">
                            <label><b>{{ 'forms-template-import.category' | locTranslate }}</b></label>
                            <app-pg-select [ariaLabel]="'forms-template-import.category' | locTranslate" [options]="categoryOptions" [(ngModel)]="selectedCategory" (ngModelChange)="selectedCategoryChange()" display="oneLine" [required]="true"></app-pg-select>
                        </div>
                        <div class="form-group" appPgAnimations="{{subcategoryVisible ? 'EnterL' : 'ExitL'}}" pgAnimationsSkipFirst>
                            <label><b>{{ 'forms-template-import.subcategory' | locTranslate }}</b></label>
                            <app-pg-select [ariaLabel]="'forms-template-import.subcategory' | locTranslate" [options]="subcategoryOptions" [(ngModel)]="selectedSubcategory" (ngModelChange)="selectedSubcategoryChange()" display="oneLine" [required]="true"></app-pg-select>
                        </div>
                        <div class="form-group">
                            <label><b>{{ 'forms-template-import.template' | locTranslate }}</b></label>
                            <app-pg-select [ariaLabel]="'forms-template-import.template' | locTranslate" [options]="templateOptions" [ngModel]="getSelectedTemplateValue()" (ngModelChange)="setSelectedTemplateValue($event)" display="oneLine"></app-pg-select>
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary" [disabled]="selectedTemplate == null" (click)="doImport()">
                                <span>{{ 'forms-template-import.use-template' | locTranslate }}</span>
                                <i class="fa-regular fa-cloud-download-alt" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1 d-none d-sm-block"></div>
            <div class="col-12 col-sm-5">
                <h4 class="mb-3">{{ 'forms-template-import.or' | locTranslate }}</h4>
                <div>
                    <div class="form-group">
                        <label><b>{{ 'forms-template-import.subtitle-without-template' | locTranslate }}</b></label>
                        <div>
                            <button type="button" class="btn btn-secondary" (click)="skipImport()">
                                <span>{{ 'forms-template-import.create-original' | locTranslate }}</span>
                                <i class="fa-regular fa-forward" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>